// extracted by mini-css-extract-plugin
module.exports = {"customDragger":"UploadFile_customDragger__1Z82-","title":"UploadFile_title__1sl5U","description":"UploadFile_description__2lBiq"};